import { defineMessages } from "react-intl"

export default defineMessages({
  platforms: {
    id: "app.components.Platforms.platforms",
  },  
})
